import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const PATIENT_OUTSTANDING_LAB_TESTS_QUERY_KEY =
  "patientOutstandingLabTests";

const STALE_TIME_MS = 1000 * 30;

/**
 * One patient's eLab tests still waiting for a final result (KIN-2087).
 *
 * Its own endpoint rather than a filter over the practice-wide list: the practice list
 * is a PHI read the backend audits against every patient on it, and a patient's own
 * screen should ask for that patient only.
 */
export const usePatientOutstandingLabTests = (patientId) => {
  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: [PATIENT_OUTSTANDING_LAB_TESTS_QUERY_KEY, tenantVal, patientId],
    queryFn: async () => {
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/healthlink/lab-orders/patient/${patientId}/outstanding`
      );

      return Array.isArray(response.data) ? response.data : [];
    },
    enabled: !!tenantVal && !!patientId,
    staleTime: STALE_TIME_MS,
    meta: {
      errorMessage: "Error fetching this patient's outstanding lab tests",
    },
  });
};
